module.exports = __webpack_public_path__ + "static/media/circo2024_hand_ballacing.c3354fee.webp";